import React, { useState, useEffect, forwardRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ptBR } from 'date-fns/locale';

// Services
import { locationService } from '../services/location.service';
import { formatterService } from '../services/formatters.service';

// Funções para DatePicker
registerLocale('ptBR', ptBR);
const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="input-group">
        <input
            type="text"
            className={`form-control custom-input-date  ${value ? 'date-selected' : ''}`}
            value={value}
            onClick={onClick}
            ref={ref}
            placeholder="DD/MM/AAAA"
            readOnly
        />
        <div className="input-group-append">
            <span className="input-group-text-date" onClick={onClick}>
                <i className='bi bi-calendar' />
            </span>
        </div>
    </div>
));

function InputDateComponent(props) {

    const [startDate, setStartDate] = useState(null);
    const [allowedDates, setAllowedDates] = useState([]);
    const [searchCity, setSearchCity] = useState(false);

    const isDateAllowed = (date) => {
        return allowedDates.some(allowedDate =>
            allowedDate.getFullYear() === date.getFullYear() &&
            allowedDate.getMonth() === date.getMonth() &&
            allowedDate.getDate() === date.getDate()
        );
    };

    const searchDates = async (date) =>{
        try {
            if (searchCity) {
                if (date) {
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    var responseDates = await locationService.fetchAvailableDaysByCity(searchCity, month, year);
                    if (responseDates) {
                        const newDates = responseDates.map(dateString => {
                            return formatterService.createLocalDate(dateString);
                        });
                        setAllowedDates(newDates);
                    }
                }
            }

        } catch (error) {
            console.error("Erro ao obter datas", error);
        }
    };

    const handleMonthChange = async (date) => {
        await searchDates(date);
    };

    const handleSelectedDate = (date) => {
        setStartDate(date);

        props.handleInput({
            target: {
                id: props.id,
                value: date
            }
        });
    };
    
    const handleCalendarOpen = async () => {
        await searchDates(startDate);
    };

    useEffect(() => {

        if (props.availableDates && props.availableDates?.length > 0) {
            const newDates = props.availableDates.map(dateString => {
                return formatterService.createLocalDate(dateString);
            });
            setAllowedDates(newDates);
        }

    }, [props.availableDates]);

    useEffect(() => {
        setSearchCity(props.searchCity);
    }, [props.searchCity]);

    return (
        <div className="form-group-date">
            {props.label ? (<label  className="form-label-date">{props.label}</label>) : ("")}

            <DatePicker
                id="datePicker"
                disabled={props.disabled}
                selected={startDate}
                onChange={date => handleSelectedDate(date)}
                filterDate={isDateAllowed}
                dateFormat="dd/MM/yyyy"
                locale="ptBR"
                customInput={<CustomInput />}
                onMonthChange={async (date) => handleMonthChange(date)}
                onCalendarOpen={async()=> handleCalendarOpen()}
            />
            
        </div>
    );
}

export default InputDateComponent;






